export function transpose(array) {
    return array[0].map((_, i) => array.map((row) => row[i]));
}
export function average(array) {
    return array.reduce((p, c) => p + c, 0) / array.length;
}
export function standardDeviation(values) {
    const avg = average(values);
    const sqrtDiff = values.map((v) => (v - avg) ** 2);
    return Math.sqrt(average(sqrtDiff));
}
export function closest(value, array) {
    return array.reduce((a, b) => {
        let aDiff = Math.abs(a - value);
        let bDiff = Math.abs(b - value);
        if (aDiff === bDiff) {
            return a > b ? a : b;
        }
        else {
            return bDiff < aDiff ? b : a;
        }
    });
}
export function countOccurences(array, value) {
    return array.reduce((a, v) => (v === value ? a + 1 : a), 0);
}
export function uniques(array, key) {
    let seen = {};
    return array.filter((item) => (seen.hasOwnProperty(item[key]) ? false : (seen[item[key]] = true)));
}
export function arrayEquals(a, b) {
    return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((v, i) => v === b[i]);
}
export function objectFlip(obj) {
    return Object.entries(obj).reduce((ret, entry) => {
        const [key, value] = entry;
        // @ts-ignore
        ret[value] = key;
        return ret;
    }, {});
}
//# sourceMappingURL=index.js.map